import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Genus, Permission, Site } from '@xanadu/model';
import { HttpClient } from '@angular/common/http';
import { UrlHelper } from '../url-helper';

@Injectable({
  providedIn: 'root'
})
export class SecureService {

    constructor(
        private readonly http: HttpClient,
        private readonly urlHelper: UrlHelper
    ) {
    }

    public permission(type: typeof Genus | typeof Site, id: string, permission: Permission): Observable<any> {
        return this.http.post<any>(this.urlHelper.of(`${type._type}/permission/${id}`), permission);
    }

    public cascade(type: typeof Genus | typeof Site, id: string, permission: Permission): Observable<any> {
        return this.http.post<any>(this.urlHelper.of(`${type._type}/cascade/${id}`), permission);
    }

    public admission(type: typeof Genus | typeof Site, id: string, admission: string[]): Observable<any> {
        return this.http.post<any>(this.urlHelper.of(`${type._type}/admission/${id}`), admission);
    }
}
